import { useRecoilValue } from "recoil";
import TrashIcon from "@rsuite/icons/Trash";
import Responsive from "../../../Components/Responsive";
import { IconButton, Input, Panel, SelectPicker } from "rsuite";
import { Airlines } from "../../../Atoms/airlines.atom";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import { useEffect } from "react";
import { DisponibilityModel } from "../../../Models/packageomra.model";
import TransfertDisponibilties from "./transfert/Transfert";
import DepartureFlights from "./departureFlights/departureFlights";
import { DisponibilityVoModel } from "../../../Models/Package.model";
import moment from "moment";
import Translation from "../../../translation/translation";
import styles from "./transfert/styles/transfertDisponibiltiesStyles";

const Disponibilities = ({ model, setModel, isUmrah }) => {
  const airlines = useRecoilValue(Airlines);

  useEffect(() => {
    setModel((prev) => {
      const sortedDisponibilities = [...prev.disponibilities].sort((a, b) => {
        if (a && !b) return -1;
        return new Date(a.date) >= new Date(b.date) ? 1 : -1;
      });
      return { ...prev, disponibilities: sortedDisponibilities };
    });
  }, [model.id]);

  const updateDisponibility = (index, updatedFields) => {
    setModel((prev) => ({
      ...prev,
      disponibilities: prev.disponibilities.map((disponibility, idx) => {
        if (idx === index) {
          const updatedFlights = disponibility.flights.map((flight) => ({
            ...flight,
            airlineId: updatedFields.airlineId,
          }));

          return {
            ...disponibility,
            ...updatedFields,
            flights: updatedFlights,
          };
        }
        return disponibility;
      }),
    }));
  };

  const handleCostChange = (cost) => {
    const costElement = model.packageUmrahCosts.find(
      (el) => el.designation.toUpperCase() === "VOL"
    );
    if (costElement) {
      const index = model.packageUmrahCosts.indexOf(costElement);
      setModel((prev) => {
        const updatedCosts = [...prev.packageUmrahCosts];
        updatedCosts[index] = {
          ...updatedCosts[index],
          cost: parseFloat(cost),
        };
        return { ...prev, packageUmrahCosts: updatedCosts };
      });
    }
  };

  const addDisponibility = () => {
    setModel((prev) => ({
      ...prev,
      disponibilities: [
        ...prev.disponibilities,
        isUmrah ? new DisponibilityModel() : new DisponibilityVoModel(),
      ],
    }));
  };

  const removeDisponibility = (index) => {
    setModel((prev) => ({
      ...prev,
      disponibilities: prev.disponibilities.filter((_, i) => i !== index),
    }));
  };

  const validateAndUpdateDisponibility = (index, value, key) => {
    const parsedValue = parseFloat(value);
    if (parsedValue >= 0) {
      updateDisponibility(index, { [key]: parsedValue });
    }
  };

  return (
    <>
      <h6>Vols</h6>
      {(!model.disponibilities || !model.disponibilities.length) && (
        <div>
          <IconButton
            onClick={addDisponibility}
            color="violet"
            icon={<PlusRoundIcon />}
          >
            ajouter
          </IconButton>
        </div>
      )}
      {model.disponibilities.map((d, i) => (
        <div key={i} className="p-10">
          <Panel
            header={
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span>{`Disponibilité ${i + 1}`}</span>
                <IconButton
                  onClick={() => removeDisponibility(i)}
                  color="violet"
                  icon={<TrashIcon />}
                  style={{ marginLeft: "10px" }}
                />
              </div>
            }
            bordered
            collapsible
            bodyFill
          >
            <Responsive className="p-10" m={6} l={2} xl={2}>
              <label>{Translation.date}:</label>
              <Input
                disabled
                type="datetime-local"
                value={moment(d.date).format("YYYY-MM-DDTHH:mm") || ""}
              />
            </Responsive>
            <Responsive className="p-10" m={6} l={2} xl={2}>
              <label>{Translation.returnDate}:</label>
              <Input
                type="datetime-local"
                value={moment(d.returnDate).format("YYYY-MM-DDTHH:mm") || ""}
                disabled
              />
            </Responsive>

            <Responsive s={2} m={1} l={0.5} xl={0.5} className="p-10">
              {d.airlineId && (
                <img
                  alt="Airline logo"
                  style={{ width: "50px" }}
                  src={airlines.find((ai) => ai.id === d.airlineId)?.logo}
                />
              )}
            </Responsive>

            <Responsive s={6} m={4} l={2.5} xl={1.3} className="p-10">
              <label>Airline:</label>
              <SelectPicker
                data={airlines.map((c) => ({ label: c.name, value: c.id }))}
                block
                value={d.airlineId}
                onSelect={(airlineId) => updateDisponibility(i, { airlineId })}
              />
            </Responsive>
            <Responsive s={6} m={4} l={2.5} xl={1.3} className="p-10">
              <label>{Translation.number}:</label>
              <Input
                type="number"
                step="1"
                min="0"
                value={d.onStock}
                onChange={(onStock) =>
                  validateAndUpdateDisponibility(i, onStock, "onStock")
                }
              />
            </Responsive>
            <Responsive s={6} m={4} l={2.5} xl={1.3} className="p-10">
              <label>{Translation.cost}:</label>
              <Input
                type="number"
                step="0.1"
                min="0"
                value={d.cost}
                onChange={(cost) =>
                  validateAndUpdateDisponibility(i, cost, "cost")
                }
              />
            </Responsive>
            <Responsive s={3} m={2} l={1.5} xl={1.5} className="p-10">
              <label>{Translation.commission}:</label>
              <Input
                type="number"
                step="0.1"
                min="0"
                value={d.commission}
                onChange={(commission) =>
                  validateAndUpdateDisponibility(i, commission, "commission")
                }
              />
            </Responsive>
            <Responsive s={3} m={2} l={1.5} xl={1.5} className="p-10">
              <label>{Translation.commissionB2B}:</label>
              <Input
                type="number"
                step="0.1"
                min="0"
                value={d.b2BCommission || 0}
                onChange={(b2BCommission) =>
                  validateAndUpdateDisponibility(
                    i,
                    b2BCommission,
                    "b2BCommission"
                  )
                }
              />
            </Responsive>

            <TransfertDisponibilties
              setModel={setModel}
              disponibilitie={d}
              index={i}
            />

            <DepartureFlights
              model={model}
              setModel={setModel}
              disponibilitie={d}
              index={i}
            />
          </Panel>

          <div style={styles.addDispo}>
            {i + 1 === model.disponibilities.length && (
              <IconButton
                onClick={addDisponibility}
                color="violet"
                icon={<PlusRoundIcon />}
              />
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export default Disponibilities;
